import { useTranslation } from 'react-i18next';

interface StaffOnlySidebarProps {
  mode: 'search' | 'results';
  onSearch?: () => void;
  onReset?: () => void;
  onExecute?: () => void;
  onBack?: () => void;
  selectedCount?: number;
  selectedSpaceType?: string;
  isLoading?: boolean;
}

/**
 * スタッフ専用共通のサイドバーコンポーネント
 * シャワールーム/防音個室ブース画像を表示
 * 検索画面: 検索/リセットボタン
 * 結果画面: 実行/戻るボタン
 */
export const StaffOnlySidebar = ({
  mode,
  onSearch,
  onReset,
  onExecute,
  onBack,
  selectedCount = 0,
  selectedSpaceType,
  isLoading = false,
}: StaffOnlySidebarProps) => {
  const { t } = useTranslation();

  const isSearchDisabled = !selectedSpaceType;
  const isExecuteDisabled = selectedCount === 0 || isLoading;

  return (
    <aside className="page__aside">
      <div className="page__side">
        <div className="e-aside-service">
          <img
            className={`e-aside-service__icon e-aside-service__icon--shower ${selectedSpaceType === 'shower_room' ? 'is-active' : ''}`}
            src="/Icon_Shower.png"
            alt={t('staffOnly.serviceType.shower')}
          />
          <img
            className={`e-aside-service__icon e-aside-service__icon--booth ${selectedSpaceType === 'private_room' ? 'is-active' : ''}`}
            src="/Icon_Booth.png"
            alt={t('staffOnly.serviceType.booth')}
          />
        </div>
        <div className="e-aside__actions">
          {mode === 'search' && (
            <>
              <button
                className={`e__btn e__btn--search ${isSearchDisabled ? 'is-disabled' : ''}`}
                type="button"
                onClick={onSearch}
                disabled={isSearchDisabled}
              >
                {t('staffOnly.buttons.search')}
              </button>
              <button
                className="e__btn e__btn--reset"
                type="button"
                onClick={onReset}
              >
                {t('staffOnly.buttons.reset')}
              </button>
            </>
          )}
          {mode === 'results' && (
            <>
              <button
                className={`e__btn e__btn--run ${isExecuteDisabled ? 'is-disabled' : ''}`}
                type="button"
                onClick={onExecute}
                disabled={isExecuteDisabled}
              >
                {isLoading
                  ? t('common.loading')
                  : t('staffOnly.buttons.execute')}
              </button>
              <button
                className="e__btn e__btn--back"
                type="button"
                onClick={onBack}
                disabled={isLoading}
              >
                {t('staffOnly.buttons.back')}
              </button>
            </>
          )}
        </div>
      </div>
    </aside>
  );
};
